/**
 * Adzuki.Address
 */

(function Address($, Adzuki)
{
	"use strict";

	var Address = {};

	/**
	 * When a country drop-down menu is changed, we need to deal with the state drop-down and options
	 *
	 * @param  jQuery Obj $country_el        the country element changed
	 * @param  int        selected_state_id  only pass in if you want to pre-populate the state after reloading the state options. For example, when "Address Same As" might be used
	 */
	Address.countryChange = function countryChange($country_el, selected_state_id)
	{
		var country_id    = $country_el.val(),
		    $parent       = $country_el.closest('.address-fields'),
		    $state_dd     = $parent.find('.state-select'),
		    $state_row    = $state_dd.closest('.form-group'),
		    $zip_required = $parent.find('.zip-required');

		$state_dd.empty();

		// hardcoding ids for U.S. and Canada because it's unlikely we are going to be maintaining states for other countries
		if ( (country_id === '183') || (country_id === '31') || (country_id === '') ) {
			$state_dd.prop("disabled", false);
			$state_row.removeClass('hidden');
			$zip_required.removeClass('hidden');

			Adzuki.Ajax.get('/States/getByCountryId/' + country_id).then(function success(response) {
				Adzuki.Address.populateState($state_dd, response, selected_state_id);
			});
		} else {
			$state_dd.prop("disabled", true);
			$zip_required.addClass('hidden');

			if (country_id !== '') {
				$state_row.addClass('hidden');
			}
		}
	};

	/**
	 * Set the options in a state drop-down menu
	 *
	 * @param  jQuery obj $state_el         the states element
	 * @param  json       data              the list of states
	 * @param  int        selected_state_id only used if you want to set "selected" for one of the state options
	 */
	Address.populateState = function populateState($state_el, data, selected_state_id)
	{
		$state_el.append($('<option>').text('Select State/Province').attr('value', ''));

		$.each(data, function parseStates(sKey, sValue) {
			$state_el.append($('<option>').text(sValue).attr('value', sKey));
		});

		if (selected_state_id !== 'undefined') {
			$state_el.val(selected_state_id);
		}
	};

	$(document).ready(function documentReady()
	{
		// check if country drop-down and state drop-down both exist
		if ( ($('.country-select').length) && ($('.state-select').length) ) {
			$('.country-select').on('change', function changeCountry() {
				Adzuki.Address.countryChange($(this));
			});
		}
	});

	Adzuki.Address = Address;

}(jQuery, window.Adzuki || {}));
